import { createStore } from "@xstate/store";

export const layoutSignal = createStore({
  context: {},
  emits: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    layoutChanged: () => {},
  },
  on: {
    updateLayout: (context, event: { type: "updateLayout" }, enqueue) => {
      enqueue.emit.layoutChanged();
      return context;
    },
  },
});
